module.exports = __webpack_public_path__ + "img/arrow.55a53e02.svg";